<template>
  <div>
    <canvas ref="canvas" />
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'IncidentBarChart',
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    customPlugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    sumPlugin() {
      return {
        afterDraw: function(chart) {
          const ctx = chart.ctx;
          ctx.save();
          const datasets = chart.data.datasets;
          const metaArr = chart.getSortedVisibleDatasetMetas();
          const lastMetaIndex = metaArr.length - 1;

          chart.data.labels.forEach((label, dataIndex) => {
            let sum = 0;
            datasets.forEach(ds => {
              sum += ds.data[dataIndex];
            });
            const topBar = metaArr[lastMetaIndex].data[dataIndex];
            if (topBar) {
              ctx.font = 'bold 12px Poppins';
              ctx.fillStyle = '#222';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              ctx.fillText(sum, topBar.x, topBar.y - 6);
            }
          });
          ctx.restore();
        }
      };
    }
  },
  watch: {
    labels: 'renderChart',
    datasets: {
      handler: 'renderChart',
      deep: true
    },
    options: {
      handler: 'renderChart',
      deep: true
    }
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      const ctx = this.$refs.canvas.getContext('2d');
      const clonedOptions = JSON.parse(JSON.stringify(this.options));
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: clonedOptions,
        plugins: [...this.customPlugins, this.sumPlugin]
      });
    }
  }
};
</script> 